module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"},"content":"<path fill-rule=\"evenodd\" d=\"M4.9 10.4L2.3 12V9.4A5 5 0 0 1 0 5.3C0 2.3 2.7 0 6 0s6 2.4 6 5.3-2.7 5.2-6 5.2a6 6 0 0 1-1.1-.1zM3.5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6zm0 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-talk.svg
// module id = 1287
// module chunks = 0